import * as React from 'react';

import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { FavoriteToggleWithCounts } from '../../../common/react/components/FavoriteToggle/FavoriteToggleWithCounts';
import { ContentType } from '../../../ts/models/ContentType';
import { ISpaceItemDetailInfo } from '../../../ts/models/ISpaceItemDetailInfo';
import { ActionsMenu } from '../ActionsMenu/ActionsMenu';
import { DetailButton } from './DetailButton';

export function FavoriteToggleIcon<C extends ContentType>(params: {
  readonly item: ISpaceItemDetailInfo<C>,
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}): JSX.Element {
  const { item, addToFavorites, removeFromFavorites } = params;

  return <FavoriteToggle canHaveKeyboardFocus={true}
                         isFavorite={item.favorite}
                         onAddFavorite={addToFavorites}
                         onRemoveFavorite={removeFromFavorites}
  />;
}

export function FavoriteToggleWithCountsIcon<C extends 'workbook' | 'datasource' | 'flow' | 'project' | 'dataRole'>(params: {
  readonly item: ISpaceItemDetailInfo<C>,
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}): JSX.Element {
  const { item, addToFavorites, removeFromFavorites } = params;
  const usageInfo = item.usageInfo;

  // in case an older server is connecting to newer front-end
  if (!usageInfo.hasOwnProperty('favoritesTotal')) {
    return FavoriteToggleIcon(params);
  }

  return <FavoriteToggleWithCounts canHaveKeyboardFocus={true}
                                   isFavorite={item.favorite}
                                   onAddFavorite={addToFavorites}
                                   onRemoveFavorite={removeFromFavorites}
                                   favoritesCount={usageInfo.favoritesTotal}
  />;
}

export function DetailButtonIcon<C extends ContentType>(
  item: ISpaceItemDetailInfo<C>,
  openDetail: () => void,
): JSX.Element {
  return <DetailButton testId={`${item.contentType}-${item.id}`} onClick={openDetail}/>;
}

export function ActionsMenuIcon<C extends ContentType>(
  item: ISpaceItemDetailInfo<C>,
  disabled?: boolean,
  buttonTitle?: string,
): JSX.Element {
  return <ActionsMenu buttonTitle={buttonTitle} targetItems={[ item ]} useIcon={true} disabled={disabled}/>;
}
